<span *ngIf="isMessagingDrawer" class="sorted-by">Sorted by impressions, high to low</span>

<div *ngIf="cardType === 'my-brand' && data.length" class="gallery-container">
  <app-creative-gallery-card *ngFor="let card of data" [cardData]="card" (click)="openCardModal(card.id)"></app-creative-gallery-card>
</div>

<div *ngIf="cardType === 'social' && socialCards.length" class="gallery-container">
  <app-social-creative-gallery-card *ngFor="let card of socialCards" [cardData]="card"></app-social-creative-gallery-card>
</div>

<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data [class]="'wide-container'" *ngIf="isEmpty && !loading"></app-no-widget-data>

